import React from 'react'
import { compose, setDisplayName } from 'recompose'
import AlertFinishedWin from '../../ui/alerts/alert-finished-win'
import AlertFinishedOutbid from '../../ui/alerts/alert-finished-outbid'
import AlertProvider from './AlertProvider'

const AlertFactory = props => {
  const { alert, ...uiProps } = props
  if (!alert) return null

  if (uiProps.wonItemCount > 0) {
    return <AlertFinishedWin {...uiProps} />
  } else {
    return <AlertFinishedOutbid {...uiProps} />
  }
}

const decorate = compose(setDisplayName('AlertFactory'), AlertProvider)

export default decorate(AlertFactory)



// WEBPACK FOOTER //
// ./src/services/notification/alert-factory.js